/**
 * Firestore query limits that every chunked `in` read in the app must respect.
 * ONE place, two numbers — read this before changing either.
 *
 * RULES_SAFE_IN_CHUNK = 8 (v3.78.1). Firestore allows 10 document reads
 * (get() / exists()) inside the security rules for ONE query. The TLS branch
 * of canReadStudent / canReadAssessment proves each `classId` in an `in` list
 * by fetching that class doc, plus the caller's own users/{uid} doc — so a
 * chunk of 10 classIds costs 11 reads and the WHOLE query is denied
 * (permission-denied), while 9 passes. The shape dates from v3.33.0; the
 * first real TLS building (Swanson, 26 classes) hit it on prod 2026-09-15,
 * after v3.77.2 had fixed the other rules-denied shapes. 8 + 1 = 9 keeps one
 * read of headroom. Teachers never own 10 classes and isAdmin() short-circuits
 * before any read, which is why only a TLS ever saw it. Pinned in
 * src/__tests__/firestore.rules.test.js ("TLS rules document-access budget").
 *
 * TWO_IN_CHUNK = 7. A query with TWO `in` clauses (classId × the four quarter
 * labels) is capped by Firestore's 30-disjunction limit after normalization:
 * 7 × 4 = 28 is under it, 8 × 4 = 32 is NOT — do not "fix" this one to 8.
 * Its rules cost is 7 + 1 = 8 reads, also within the budget.
 */
export const RULES_SAFE_IN_CHUNK = 8;
export const TWO_IN_CHUNK = 7;
